export const styles = {
  helperText: {
    marginBottom: 12,
    color: '#6B7280',
  },
  label: {
    marginBottom: 6,
  },
  error: {
    marginTop: 8,
  },
  footerBtn: {
    minWidth: 180,
  },
  footerBtnSecondary: {
    minWidth: 120,
  },
  headingTitle: {
    fontSize: 14,
    color: '#6B7280',
    fontWeight: 600,
    lineHeight: '18px',
  },
  headingSubtitle: {
    marginTop: 4,
  },
};
  
